import React, { useEffect, useRef } from "react";

import { ADSENSE_CLIENT } from "../utils/site";

/**
 * A display ad unit.
 *
 * Renders nothing unless a slot id is supplied. Slot ids are issued by AdSense
 * once a site is approved, and pushing an invalid one produces console errors
 * and an empty box, so an unconfigured slot is better left out of the page
 * entirely than filled with a placeholder.
 */
const AdSlot = ({ slot, format = "auto", className = "" }) => {
  const pushed = useRef(false);

  useEffect(() => {
    if (!slot || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushed.current = true;
    } catch {
      // An ad blocker or a failed script load; the page is fine without it.
    }
  }, [slot]);

  if (!slot) return null;

  return (
    <div className={`ad-slot ${className}`.trim()}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSlot;
